/**
 * Represents the state machine.
 */
export class Flow {
    static parseJSONstring(json) {
        return JSON.parse(json);
    }
    toJSONstring() {
        return JSON.stringify(this);
    }
}
